import { db, img } from './firebase';
import firebase from 'firebase';

let getPostcardsCollection = db.collection('postcards');

export const getPostcards = context => {
  getPostcardsCollection.onSnapshot(querySnapshot => {
    let postcards = [];
    let markers = [];
    querySnapshot.forEach(doc => {
      postcards.push(Object.assign({ id: doc.id }, doc.data()));
    });

    postcards.sort((a, b) => {
      if (a.date > b.date) {
        return -1;
      }
      if (a.date < b.date) {
        return 1;
      }
      return 0;
    });

    postcards.forEach(item => {
      let lat = item.location.latitude;
      let lng = item.location.longitude;
      if (
        lat < -90 ||
        lat > 90 ||
        lng < -180 ||
        lng > 180 ||
        typeof lat == 'undefined' ||
        typeof lng == 'undefined'
      ) {
        markers.push([Number.MAX_VALUE, Number.MAX_VALUE]);
      } else {
        markers.push([lat, lng]);
      }
    });

    context.setState({ postcards });
    context.setState({ markers });
  });
};

export const uploadPostcards = (context, postcard) => {
  const lat = Math.round(postcard.location.lat * 1000000) / 1000000;
  const lng = Math.round(postcard.location.lng * 1000000) / 1000000;
  const location = new firebase.firestore.GeoPoint(lat, lng);
  const newPostcard = { ...postcard, location: location };
  return getPostcardsCollection
    .add(newPostcard)
    .then(() => {
      context.props.handleClose();
    })
    .catch(error => {
      context.setState({
        errorMessage: error,
        isErrorDialogOpen: true
      });
    });
};

export const uploadImage = file => {
  const metadata = { contentType: 'image/jpeg' };
  const myRef = img.ref();
  return myRef.child(`postcards/${file.name}`).put(file, metadata);
};

export const getImage = imgName => {
  const myRef = img.ref();
  const myImageRef = myRef.child(`postcards/${imgName}`);
  return myImageRef.getDownloadURL();
};

export function deleteItem(postcard) {
  getPostcardsCollection.doc(postcard).delete();
}
